import React from 'react';
import PropTypes from 'prop-types';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import YesNoUnknown from '../../PropertyDetail/YesNoUnknown';

import './Taxation.css';

const TaxationComponent = ({ taxation }) => (
  <div>
    {(taxation.taxSummary !== undefined && taxation.taxSummary !== '' && taxation.taxSummary !== 0) &&
      <div className="taxation-details">
        <ViewerPrimaryColorUserStyle domStyle="color">
          <h3>Tax Summary</h3>
        </ViewerPrimaryColorUserStyle>
        <p> {taxation.taxSummary}</p>
      </div>
      }
    {(taxation.salesTaxRate !== undefined && taxation.salesTaxRate !== '' && taxation.salesTaxRate !== 0) &&
      <div className="taxation-details">
        <ViewerPrimaryColorUserStyle domStyle="color">
          <h3>Sales Tax Rate</h3>
        </ViewerPrimaryColorUserStyle>
        <p>{taxation.salesTaxRate}</p>
      </div>
      }
    {(taxation.corporateTaxRate !== undefined && taxation.corporateTaxRate !== '' && taxation.corporateTaxRate !== 0) &&
      <div className="taxation-details">
        <ViewerPrimaryColorUserStyle domStyle="color">
          <h3>Corporate Tax Rate</h3>
        </ViewerPrimaryColorUserStyle>
        <p>{taxation.corporateTaxRate}</p>
      </div>
      }
    {(taxation.incomeDeductible !== undefined && taxation.incomeDeductible !== '') &&
      <div className="taxation-details">
        <ViewerPrimaryColorUserStyle domStyle="color">
          <h3>State Income Tax Deductible on Federal Return</h3>
        </ViewerPrimaryColorUserStyle>
        <YesNoUnknown value={taxation.incomeDeductible} />
      </div>
      }
    {(taxation.individualTaxRate !== undefined && taxation.individualTaxRate !== '' && taxation.incomeDeductible !== 0) &&
      <div className="taxation-details">
        <ViewerPrimaryColorUserStyle domStyle="color">
          <h3>Individual Tax Rate</h3>
        </ViewerPrimaryColorUserStyle>
        <p>{taxation.individualTaxRate}</p>
      </div>
      }
  </div>
);

TaxationComponent.propTypes = {
  taxation: PropTypes.shape({
    taxSummary: PropTypes.string,
    salesTaxRate: PropTypes.string,
    corporateTaxRate: PropTypes.string,
    incomeDeductible: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    individualTaxRate: PropTypes.string,
  }),
};

export default TaxationComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaDetails/Taxation.js